<template>
    <modal dialog="modal-lg" class="dark-top" :footer="true">
        <div slot="title">
            <h2>New resource</h2>
        </div>
        <div slot="body">
            <resource-form @toggleIsDisabled="toggleIsDisabled" @readyToSave="readyToSave"></resource-form>

        </div>

        <div slot="footer" class="d-flex flex-all">
            <button type="button" class="btn cancel wider" @click="cancel">Cancel</button>
            <button type="button" class="btn ok wider" @click="save" :disabled="isDisabled || getIsAddingItem">Save</button>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Modal from './Modal'
    import ResourceForm from '@/components/inventory/resources/ResourceForm'
    import {eventHub} from '@/main'

    export default {
        data: function() {
            return {
                isDisabled: true,
                updatedForm: null,
            }
        },
        computed: {
            ...mapGetters([
                'account',
                'getIsAddingItem'
            ])
        },
        methods: {
            ...mapActions([
                'closeModal',
                'addItem'
            ]),
            toggleIsDisabled: function(isDisabled) {
                this.isDisabled = isDisabled;
            },
            cancel: function() {
                this.closeModal();
            },
            readyToSave: function (updatedForm) {
                this.updatedForm = updatedForm;
            },
            save: function() {
                if (this.updatedForm) {
                    if (!this.updatedForm.availability) {
                        this.updatedForm.availability = 0;
                    }

                    this.addItem({
                        object: 'resource',
                        action: 'create',
                        table: 'resources',
                        fields: { supplierId: this.account.supplierId, resource: this.updatedForm }
                    }).then((response) =>{
                        eventHub.$emit('updatedResources');
                    });
                }
            }
        },
        components: {
            Modal,
            ResourceForm
        }
    }
</script>



// WEBPACK FOOTER //
// ResourceAdd.vue?7a2c9f38